import { FC } from 'react';
import { useMutation } from '@/hooks/graphql/useMutation';
import { useNotify } from '../../../../../../hooks/useNotify';
import styles from './DeleteHealthCheckupInstitution.scss';
import {
  DELETE_HEALTH_CHECKUP_INSTITUTION,
  DeleteHealthCheckupInstitutionQueryVariables,
  HealthCheckupInstitution
} from './mutation';
import { Delete } from 'jbc-front/components/icons';
import { Modal } from '../../../../../../components';
import { Description } from '../Description';
import Button from 'jbc-front/components/Button';

interface DeleteHealthCheckupInstitutionParams {
  healthCheckupInstitution: HealthCheckupInstitution;
  refetch: () => void;
  className?: string;
}

export const DeleteHealthCheckupInstitution: FC<DeleteHealthCheckupInstitutionParams> = ({
  healthCheckupInstitution,
  refetch,
  className
}) => {
  const notify = useNotify();

  const [deleteHealthCheckupInstitution, { loading: deleting }] = useMutation<
    unknown,
    DeleteHealthCheckupInstitutionQueryVariables
  >(DELETE_HEALTH_CHECKUP_INSTITUTION);

  const onSubmit = async () => {
    await deleteHealthCheckupInstitution({
      variables: {
        input: {
          id: parseInt(healthCheckupInstitution.id, 10)
        }
      }
    });
    notify('削除しました', 'success');
    refetch();
  };

  return (
    <Modal>
      {({ hideModal, showModal, isOpen }) => {
        return (
          <>
            <Description text="削除">
              <span className={className} onClick={() => showModal()}>
                <Delete size={20} />
              </span>
            </Description>
            {isOpen && (
              <form>
                <Modal.Modal>
                  <div className={styles.modal}>
                    <Modal.Header hideModal={hideModal}>削除確認</Modal.Header>
                    <Modal.Body>
                      <div className={styles.modalBody}>
                        <div className={styles.healthCheckupInstitutionItem}>
                          <p className={styles.warningText}>削除された健康診断実施機関は復元することができません。</p>
                          <p>健康診断実施機関を削除してよろしいですか？</p>
                        </div>
                        <div className={styles.healthCheckupInstitutionItem}>
                          <div>ID</div>
                          <div>{healthCheckupInstitution.healthCheckupInstitutionId}</div>
                        </div>
                        <div className={styles.healthCheckupInstitutionItem}>
                          <div>名称</div>
                          <div>{healthCheckupInstitution.name}</div>
                        </div>
                        <div className={styles.healthCheckupInstitutionItem}>
                          <div>所在地</div>
                          <div>{healthCheckupInstitution.location}</div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <div className={styles.modalFooter}>
                        <Modal.Buttons>
                          <Button className={styles.cancelButton} onClick={hideModal}>
                            いいえ
                          </Button>
                          <Button className={styles.sendButton} primary onClick={onSubmit} disabled={deleting}>
                            はい
                          </Button>
                        </Modal.Buttons>
                      </div>
                    </Modal.Footer>
                  </div>
                </Modal.Modal>
              </form>
            )}
          </>
        );
      }}
    </Modal>
  );
};
